<script>
import { mapGetters } from 'vuex';
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    // Served from public/, so it must stay a runtime path: a literal src in the
    // template makes Vite try to resolve it as a module at build time.
    markSrc() {
      return '/brand-assets/logo-3d.svg';
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full">
    <!-- Teletel: the empty state carries the dimensional mark. It reads the
         same in both themes, so it needs no light/dark pair; the flat logo
         stays the brand asset everywhere else. -->
    <img
      class="block w-40 m-4"
      :src="markSrc"
      :alt="globalConfig.installationName"
    />
    <span class="text-sm font-medium text-center text-n-slate-12">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
